import { Component } from "react"
import "./PremiumPage.css"


class FeatureList extends Component {
    render() {
        return (
            <div className="plan-features-container">
                <p className="plan-features-subtitle">Included with Lifetime Access</p>
                <ul className="plan-features plan-features-grid">
                    <li><span className="plan-check">&#10003;</span> Unlimited valuations</li>
                    <li><span className="plan-check">&#10003;</span> Price trend graphs</li>
                    <li><span className="plan-check">&#10003;</span> All comparables</li>
                </ul>
            </div>
        )
    }
}

export default FeatureList
